import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { NgStyle } from '@angular/common';
import { Icon } from '../icon/icon';
import { ActionButtonAppearance, ActionButtonContent, IconsEnum, IconSize } from '@/shared/enums';

@Component({
  selector: 'bevvi-action-button',
  imports: [NgStyle, Icon],
  templateUrl: './action-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionButton {
  public readonly label = input<string>('');
  public readonly icon = input<IconsEnum>(IconsEnum.NONE);
  public readonly disabled = input(false);
  public readonly appearance = input<ActionButtonAppearance>(ActionButtonAppearance.GHOST);
  public readonly contentType = input<ActionButtonContent>(ActionButtonContent.ICON_TEXT);
  public readonly textColor = input('var(--color-solid-black-500)');
  public readonly hoverTextColor = input('var(--color-solid-black-500)');
  public readonly fillColor = input('var(--color-solid-blush-300)');
  public readonly hoverFillColor = input('var(--color-solid-blush-300)');

  public readonly buttonClick = output<void>();

  protected readonly iconsEnum = IconsEnum;
  protected readonly iconSize = IconSize;
  protected readonly actionButtonContent = ActionButtonContent;

  protected readonly buttonStyles = computed(() => ({
    '--btn-text': this.textColor(),
    '--btn-hover-text': this.hoverTextColor(),
    '--btn-bg':
      this.appearance() === ActionButtonAppearance.FILLED ? this.fillColor() : 'transparent',
    '--btn-hover-bg': this.hoverFillColor(),
  }));
}
